import { IDynamicObject, ModelConstructor } from "xa-generics";
import { CourierIncomeModel } from "../../../Models/CourierIncome.model";
import { CourierOrderModel } from "../../../Models/CourierOrder.model";
import { PaymentSummaryModel } from "./PaymentSummary.model";

export class CourierSummaryModel extends PaymentSummaryModel {
    constructor(data?: IDynamicObject<any>) {
        super(data);
        if (!data) return;
        ModelConstructor(data, this);

        if (typeof data.incomes === "object") {
            this.incomes = new CourierIncomeModel(data.incomes);
        }

        if (data.orders instanceof Array) {
            this.orders = data.orders.map((item: IDynamicObject) => new CourierOrderModel(item));
        }
    }

    distance: number = 0;
    distance_km: number = 0;
    distance_price: number = 0;

    //The kilometres above are LCT's own; this is the money side of the same interval.
    incomes: CourierIncomeModel = new CourierIncomeModel();

    //The very orders the incomes were added up from, so one of them can be moved to another courier
    orders: CourierOrderModel[] = [];
}
